import React from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '@/store/hooks';
import { selectWidget } from '@/features/dashboard/dashboardSlice';
import DashboardChartWidget from '@/util/DashboardChartWidget';
import { createCustomEvent } from '@/util/createCustomEvent';
import { DASHBOARD_PREVIEW_WIDGET_CREATED } from '@/constants/custom-event-names';

const Title = styled.h4`
  text-align: center;
`;

export const PreviewWidget: React.FC<{
  index: number;
  widget: DashboardChartWidget;
}> = ({ index, widget }) => {
  const dispatch = useAppDispatch();
  const titleRef = React.useRef<HTMLHeadingElement>(null);

  React.useEffect(() => {
    window.dispatchEvent(
      createCustomEvent(
        DASHBOARD_PREVIEW_WIDGET_CREATED,
        titleRef.current?.parentElement?.parentElement?.parentElement?.getBoundingClientRect(),
      ),
    );
  }, []);

  React.useEffect(() => {
    dispatch(
      selectWidget({
        view: null,
        selectedChartWidgetIndex: index,
        displayType: 'preview' as any,
        dataTable: null,
        chartConfiguration: null,
        widgetTitle: null,
        widget,
      }),
    );
  }, [index]);

  return <Title ref={titleRef}>Select a saved query</Title>;
};
